import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import BeforeAfter from "@/components/site/BeforeAfter";
import Process from "@/components/site/Process";
import ServiceArea from "@/components/site/ServiceArea";
import { usePageMeta } from "@/lib/usePageMeta";

export default function Home() {
  usePageMeta(
    "Milwaukee & Power Tool Repair Newcastle | NE Tool Repair",
    "Independent Milwaukee M12 & M18 power tool repair and refurbishment in Newcastle upon Tyne and the North East. Request a repair online or message us on WhatsApp.",
    "/"
  );
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Services />
      <BeforeAfter />
      <Process />
      <ServiceArea />
    </div>
  );
}
